export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Início',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Registro',
  'menu.register-result': 'Resultado de registro',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Análise',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Ambiente de Trabalho',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Formulário',
  'menu.form.basic-form': 'Formulário Básico',
  'menu.form.step-form': 'Formulário Assistido',
  'menu.form.step-form.info':
    'Formulário Assistido(gravar informações de transferência)',
  'menu.form.step-form.confirm':
    'Formulário Assistido(confirmar informações de transferência)',
  'menu.form.step-form.result': 'Formulário Assistido(finalizado)',
  'menu.form.advanced-form': 'Formulário Avançado',
  'menu.list': 'Lista',
  'menu.list.table-list': 'Tabela de Busca',
  'menu.list.basic-list': 'Lista Básica',
  'menu.list.card-list': 'Lista de Card',
  'menu.list.search-list': 'Lista de Busca',
  'menu.list.search-list.articles': 'Lista de Busca(artigos)',
  'menu.list.search-list.projects': 'Lista de Busca(projetos)',
  'menu.list.search-list.applications': 'Lista de Busca(aplicações)',
  'menu.profile': 'Perfil',
  'menu.profile.basic': 'Perfil Básico',
  'menu.profile.advanced': 'Perfil Avançado',
  'menu.result': 'Resultado',
  'menu.result.success': 'Sucesso',
  'menu.result.fail': 'Falha',
  'menu.exception': 'Exceção',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Disparar',
  'menu.account': 'Conta',
  'menu.account.center': 'Central da Conta',
  'menu.account.settings': 'Configurar Conta',
  'menu.account.trigger': 'Disparar Erro',
  'menu.account.logout': 'Sair',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  
  // Activity Management
  'menu.activity': 'Gerenciamento de Atividades',
  'menu.activity-list': 'Lista de Atividades',
  'menu.activity-create': 'Criar Atividade',
  'menu.activity-edit': 'Editar Atividade',
  'menu.activity-verification': 'Gerenciamento de Verificação',
  
  // User Management
  'menu.user-management': 'Gerenciamento de Usuários',
  'menu.user-list': 'Lista de Usuários',
  'menu.user-detail': 'Detalhes do Usuário',
  'menu.operator-management': 'Gerenciamento de Operadores',
  
  // Order Management
  'menu.order': 'Gerenciamento de Pedidos',
  'menu.order-list': 'Lista de Pedidos',
  'menu.order-detail': 'Detalhes do Pedido',
  'menu.refund-management': 'Gerenciamento de Reembolsos',
  
  // Mall Management
  'menu.mall': 'Gerenciamento de Shopping',
  'menu.product-management': 'Gerenciamento de Produtos',
  'menu.product-create': 'Adicionar Produto',
  'menu.product-edit': 'Editar Produto',
  'menu.inventory-management': 'Gerenciamento de Estoque',
  'menu.logistics-management': 'Gerenciamento de Logística',
  
  // Statistics
  'menu.statistics': 'Estatísticas',
  'menu.statistics-overview': 'Visão Geral das Estatísticas',
  'menu.activity-statistics': 'Estatísticas de Atividades',
  'menu.sales-statistics': 'Estatísticas de Vendas',
  
  // System Management
  'menu.system': 'Gerenciamento do Sistema',
  'menu.system-config': 'Configuração do Sistema',
  'menu.system-logs': 'Logs de Operação',
};
